import React from 'react';
import "../App.css";



class Footer extends React.Component {

  render() {
   
    return (
        <footer className="page-footer font-small" >
        <div className="footer-copyright text-center py-3">
          <a href="https://satisheagle.netlify.app" target="_blank">Copyright © 2019 Satish Eagle.</a>
        </div>
    </footer>
      
    );
  }
}

export default Footer;
